import { render, staticRenderFns } from "./RedeemBountyButton.vue?vue&type=template&id=350111d6&scoped=true"
import script from "./RedeemBountyButton.vue?vue&type=script&lang=js"
export * from "./RedeemBountyButton.vue?vue&type=script&lang=js"
import style0 from "./RedeemBountyButton.vue?vue&type=style&index=0&id=350111d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350111d6",
  null
  
)

export default component.exports